require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-first-cu-president-featured-in-bloomberg-businessweek.json") })
        }
      }, "path---articles-financial-center-first-cu-president-featured-in-bloomberg-businessweek");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-first-cu-president-featured-in-bloomberg-businessweek!./.cache/json/articles-financial-center-first-cu-president-featured-in-bloomberg-businessweek.json
// module id = 1623
// module chunks = 231608221292675